import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { OAuthLogin } from './components/OAuthLogin'
import { OAuthCallback } from './components/OAuthCallback'
import { RootLayout } from './layouts/RootLayout'
import { HomePage } from './pages/HomePage'
import { AlbumsPage } from './pages/AlbumsPage'
import { ParentCommentSyncPage } from './pages/ParentCommentSyncPage'
import { LineNotifyPage } from './pages/LineNotifyPage'
import { SettingsPage } from './pages/SettingsPage'
import { ProfilePage } from './pages/ProfilePage'

/**
 * ルートコンポーネント
 *
 * 認証状態に応じてOAuthLoginまたはルーティングされたページを表示。
 */
export function App() {
  const { isAuthenticated, login } = useAuth()

  // 未認証の場合はOAuthログインまたはコールバック処理
  if (!isAuthenticated) {
    const router = createBrowserRouter([
      {
        path: '/',
        element: <OAuthLogin />,
      },
      {
        path: '/auth/callback',
        element: <OAuthCallback onLogin={login} />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ])

    return <RouterProvider router={router} />
  }

  // 認証済みの場合はルーティングを有効化
  const router = createBrowserRouter([
    {
      path: '/',
      element: <RootLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="/home" replace />,
        },
        {
          path: 'home',
          element: <HomePage />,
        },
        {
          path: 'albums',
          element: <AlbumsPage />,
        },
        {
          path: 'parent-comment',
          element: <ParentCommentSyncPage />,
        },
        {
          path: 'line',
          element: <LineNotifyPage />,
        },
        {
          path: 'settings',
          element: <SettingsPage />,
        },
        {
          path: 'profile',
          element: <ProfilePage />,
        },
      ],
    },
  ])

  return <RouterProvider router={router} />
}
